import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card } from 'react-bootstrap';

const AboutUsPage = () => {
  return (
    <Container className="my-5">
      <Helmet>
        <title>Sobre Nosotros | AECBlock — Marketplace para Profesionales AEC</title>
        <meta name="description" content="Conoce AECBlock: la plataforma creada por y para profesionales de Arquitectura, Ingeniería y Construcción. Herramientas técnicas validadas por expertos del sector." />
        <link rel="canonical" href="https://aecblock.com/nosotros" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Sobre Nosotros | AECBlock" />
        <meta property="og:description" content="AECBlock: la plataforma creada por y para profesionales de Arquitectura, Ingeniería y Construcción." />
        <meta property="og:url" content="https://aecblock.com/nosotros" />
        <meta property="og:image" content="https://aecblock.com/default-og-image.png" />
      </Helmet>
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <Card className="p-4 shadow-sm">
            <Card.Body>
              <h1 className="text-center mb-4">SOBRE NOSOTROS</h1>
              <p className="lead text-center mb-5">
                Transformamos herramientas cotidianas en soluciones digitales de alto impacto.
              </p>

              <p>
                AECBlock es una plataforma creada por y para profesionales de la Arquitectura, Ingeniería y Construcción. Aquí reunimos herramientas desarrolladas por especialistas del sector: scripts, modelos 3D, plantillas de cálculo, automatizaciones y recursos que nacieron del trabajo diario y ahora están disponibles para potenciar tu productividad.
              </p>
              <p>
                No vendemos productos genéricos: curamos, revisamos y validamos cada archivo para asegurar su utilidad técnica. Nuestro compromiso es democratizar el acceso a soluciones inteligentes, creadas por profesionales que conocen de primera mano los retos del entorno AEC.
              </p>
              <p>
                Impulsamos una comunidad técnica global que comparte conocimiento aplicado, eleva estándares de calidad y acelera la transformación digital en cada etapa del proyecto constructivo.
              </p>
              <p className="text-center mt-4 lead fw-bold">
                🎯 Profesional. Confiable. Hecho por expertos, para expertos.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUsPage;